import React from "react"
import { Box, Container } from "theme-ui"
import ContactFormFull from "./contactFormFull"
import SectionTitle from "./sectionTitle"

const Form = ({ title }) => (
  <Box>
    <Container>
      {title && <SectionTitle title={title} />}
      <ContactFormFull />
    </Container>
  </Box>
)

export default Form
